import {type Dispatch, useState} from 'react';
import {Stack, Tooltip, Typography} from '@mui/material';
import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
import {FishGroupModelAssignmentMenu} from './FishGroupModelAssignmentMenu';
import {type QualityModelArguments, type WriteQualityModelAttribute} from 'client';
import {useTranslation} from 'react-i18next';
import {mixedQuality, ModelIcon} from './FishGroupQualityModelAssignmentIcon';
import {MixedIcon} from 'styles/icons';
import {type IFishGroup, type IFishGroupAction} from './helpers/reducer';

interface FishGroupModelAssignmentRowProps {
  label: string;
  value: string;
  nameIsCustom?: boolean;
  sendModel: (model: QualityModelArguments) => void;
}

export const FishGroupModelAssignmentRow = ({
  state,
  dispatch,
}: {
  state: IFishGroup;
  dispatch: Dispatch<IFishGroupAction>;
}): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const {t} = useTranslation('common');

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  // TODO: move this somewehre nicer
  const isMixed = mixedQuality(state.fishGroups ?? []) && !state.qualityModelEdited;

  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Stack direction={'row'} width={90} alignItems={'center'} spacing={0.5}>
        <Typography variant="body2" color={'secondary'}>
          {t('quality')}
        </Typography>
        <CustomDot qualityAttribute={state?.qualityModelAttribute} />
      </Stack>
      <FishGroupModelAssignmentMenu
        open={open}
        anchorEl={anchorEl}
        handleCloseMenu={handleCloseMenu}
        state={state}
        dispatch={dispatch}
      />
      <Stack
        direction={'row'}
        alignItems={'center'}
        spacing={1}
        onClick={handleOpenMenu}
        sx={{cursor: 'pointer'}}
        data-testid="quality-model"
      >
        {isMixed ? (
          <MixedIcon fontSize={'inherit'} />
        ) : (
          state?.qualityModelAttribute?.assignmentType &&
          ModelIcon(state.qualityModelAttribute?.assignmentType, 'inherit')
        )}
        <Typography variant="body2">
          {isMixed
            ? t('mixed')
            : state?.qualityModelAttribute?.assignmentType
              ? t(state?.qualityModelAttribute?.assignmentType)
              : ''}
        </Typography>
      </Stack>
    </Stack>
  );
};

const CustomDot = ({qualityAttribute}: {qualityAttribute?: WriteQualityModelAttribute}) => {
  const {t} = useTranslation('common');
  return qualityAttribute?.isPinned ? (
    <Tooltip title={t('isEdited')}>
      <DriveFileRenameOutlineRoundedIcon fontSize={'inherit'} color="primary" />
    </Tooltip>
  ) : null;
};
